import {https,httpsFile} from './http.js';
export function index(){
    return httpsFile().get(`/plant-branches`);
}

export function plant_storloc(){
    return httpsFile().get(`/showPlantStorloc`);
}

export function getAssigned(){
    return httpsFile().get(`/getAssignedPlant`);
}
export function getStoreLoc(includeDmg,include9090 = false){
    return httpsFile().get(`/getStoreLoc?includeDmg=${includeDmg}&include9090=${include9090}`);
}
export function showStorlocList(){
    return httpsFile().get(`/showStorlocList`);
}
export function getDmgStoreLoc(plant){
    return httpsFile().get(`/getDmgStoreLoc?plant=${plant}`);
}

export function show( company ){
    return https( ).get( `/plant-branches/${company}` );
}
export function showPlant( company ){
    return https( ).get( `/showPlant?company=${company}` );
}
export function showStorloc(plant,show9090 = false){
    return https( ).get( `/showAllStorLoc?plant=${plant}&show9090=${show9090}` );
}
export function showBranchShortNameReport(plant,show9090 = false){
    return https( ).get( `/showBranchShortNameReport` );
}